import React, { useState, useEffect } from "react";
import { useSignal, useSlot } from 'react-signal-slot';
import { IPersonalData } from '../../Tables/types'
import PersonalDataTable from "../../Tables/PersonalDataTable"
import Fetcher from "../../Common/Fetch";
import { fetcherGET, fetcherPOSTJSON, fetcherPOST } from "../../Common/Fetch";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import useFetchPost from "../../Hooks/useFetchPost";
import Loading from "../../Ui/Loading";

function PersonalData() {

    const [showDevtools, setShowDevtools] = useState(false);

    //useEffect(() => {
    //    const toggleDevtools = (e) => {
    //        if (e.altKey && e.key === "s") {
    //            setShowDevtools((prev) => !prev);
    //        }
    //    };

    //    window.addEventListener("keydown", toggleDevtools);
    //    return () => window.removeEventListener("keydown", toggleDevtools);
    //}, []);

    return (
        <>
            <h4 className="purpleTextHead">Личные данные</h4>
            <PersonalDataTable />
            
        </>
    )
}

export default PersonalData;

//{ showDevtools && <ReactQueryDevtools initialIsOpen={false} /> }